import { useGetEntities } from '@abaninja/util-store';

import { getDeepBoxBoxes } from '../connections/deepboxes';

export const useDeepBoxBoxesStore = () => useGetEntities(getDeepBoxBoxes);
